/**
 * Vanilla JavaScript exports for Advanced Grid Library
 */

// Import CSS automatically
import '../styles/globals.css';

// Core types and utilities
export type { 
  GridColumn, 
  SortingState, 
  FilteringState, 
  PaginationState,
  ServerSideConfig,
  ServerSideRequest,
  ServerSideResponse,
  ServerSideError,
  ServerSideState,
  GridOptions
} from '../core/types';

export * from '../core/lib/data-manager';
export { cn } from '../core/utils';
export * from '../core/utils/pagination';

// Vanilla JavaScript implementation would go here
export class VanillaAdvancedGrid {
  constructor(container: HTMLElement, options: any) {
    // Vanilla implementation would go here
    console.log('VanillaAdvancedGrid initialized', container, options);
  }
}
